import * as _ from 'lodash-es'
import {
  NavigationGuardNext,
  RouteLocationNormalized,
  createRouter,
  createWebHistory,
} from 'vue-router'

import {
  PERFORMANCE_FLOW_ROUTES,
  PERFORMANCE_RESERVATION_ROUTES,
} from '@/modules/performance/constants/PerformanceRouteConstants'
import { guestRoutes } from '@/router/guest-routes'
import { venueRoutes } from '@/router/venue-routes'
import { useUserStore } from '@/stores/user'
import loc from '@/utils/loc'

import { UserGroupType } from '@generated/types'

export async function beforeEach(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) {
  const userStore = useUserStore()
  const requiredGroup = to.meta?.requiresAuth as UserGroupType | undefined
  if (requiredGroup) {
    if (!userStore.isLoggedIn) {
      console.error(`Attempted to navigate to ${to.fullPath}, but not logged in`)
      loc.redirect(`/accounts/login/?next=${to.fullPath}`)
      return next(false)
    } else {
      await userStore.loading
      if (!userStore.hasGroup(requiredGroup)) {
        console.error(`Attempted to navigate to ${to.fullPath}, but not in ${requiredGroup}`)
        return next(new Error('Unauthorized'))
      }
    }
  }
  if (to.fullPath.startsWith('/#')) {
    return next(to.fullPath.slice(2))
  }
  return next()
}

export async function afterEach(to: RouteLocationNormalized) {
  if (window.dataLayer) {
    let pageTitle = to.meta?.pageTitle || to.name
    if (to.fullPath.includes('venue')) {
      pageTitle = 'Venue - ' + pageTitle
    }
    window.dataLayer.push({
      event: 'page_view',
      page_path: to.fullPath,
      page_name: to.name,
      page_title: pageTitle,
    })
  }

  useUserStore().hotjarIdentification()
}

export function mkRouter() {
  const router = createRouter({
    routes: [...guestRoutes, ...venueRoutes],
    history: createWebHistory(),
  })
  router.beforeEach(beforeEach)
  router.afterEach(afterEach)
  return router
}

export function isNavigatingAmongPerfFlow(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
): boolean {
  if (!to.params.performanceId) return false
  return (
    _.values(PERFORMANCE_FLOW_ROUTES).includes(to.name) &&
    _.values(PERFORMANCE_FLOW_ROUTES).includes(from.name) &&
    to.params.performanceId === from.params.performanceId
  )
}

export function isNavigatingFromPerfResToPerfFlow(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
): boolean {
  if (!to.params.performanceId) return false
  return (
    _.values(PERFORMANCE_FLOW_ROUTES).includes(to.name) &&
    _.values(PERFORMANCE_RESERVATION_ROUTES).includes(from.name) &&
    to.params.performanceId === from.params.performanceId
  )
}
